import { render } from "./TransactionSummary.vue?vue&type=template&id=261c0ee2"
import script from "./TransactionSummary.vue?vue&type=script&lang=js"
export * from "./TransactionSummary.vue?vue&type=script&lang=js"
script.render = render

export default script